import i18n from '@/language/i18n';
import EMPLOYEES_WIDGETS from '../widgets/EMPLOYEES_WIDGETS';

const EMPLOYEES_MODULE_WINDOW_IDENTIFIER = Object.freeze({
  EMPLOYEES_MODULE_WINDOW_ID: 'employees',
  USERS_MODULE_WINDOW_ID: 'users',
  ROLES_MODULE_WINDOW_ID: 'roles',
  ACCESSGROUPS_MODULE_WINDOW_ID: 'accessgroups',
  OCCUPATION_GROUPS_MODULE_WINDOW_ID: 'occupationgroups',
  GROUPS_MODULE_WINDOW_ID: 'groups',
  DEPARTMENTS_MODULE_WINDOW_ID: 'departments',
  DEPUTY_TYPE_MODULE_WINDOW_ID: 'deputytypes',
  CURRICULUM_VITAE_MODULE_WINDOW_ID: 'curriculumvitae',
  SKILL_MATRIX_MODULE_WINDOW_ID: 'skillmatrix',
  SKILL_CATEGORIES_MODULE_WINDOW_ID: 'skillcategories',
});

export { EMPLOYEES_MODULE_WINDOW_IDENTIFIER };

export default {
  EMPLOYEES_GROUP_WRAPPER: {
    type: 'group',
    id: 'employees',
    label: i18n.t('ModuleRegistry.groups.personal.name'),
    children: [],
    icon: '$wCustomer',
    sidebarIcon: '$wNavEmployees'
  },
  CHILDREN: {
    EMPLOYEES_MODULE: {
      type: 'module',
      id: 'employeesOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.EMPLOYEES_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.employeesOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_mitarbeiter.svg'),
      routerLink: '/employees',
      globalSearch: {
        index: 'employees',
        presentation: i18n.t(
          'ModuleRegistry.groups.personal.employeesOverview.presentation'
        ),
        component: 'EmployeeItem.vue',
        shortcut: '-e'
      },
      widgets: EMPLOYEES_WIDGETS.EMPLOYEES_OVERVIEW_WIDGETS
    },
    USERS_MODULE: {
      type: 'module',
      id: 'userOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.USERS_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.userOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_benutzer.svg'),
      routerLink: '/users',
      globalSearch: {
        index: 'users',
        presentation: i18n.t(
          'ModuleRegistry.groups.personal.userOverview.presentation'
        ),
        component: 'UserItem.vue',
        shortcut: '-u'
      },
      widgets: EMPLOYEES_WIDGETS.USERS_OVERVIEW_WIDGETS
    },
    ROLES_MODULE: {
      type: 'module',
      id: 'roleOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.ROLES_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.roleOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_rolle.svg'),
      routerLink: '/roles',
      globalSearch: {
        index: 'roles',
        presentation: i18n.t('ModuleRegistry.groups.personal.roleOverview.label'),
        component: 'RoleItem.vue',
      },
      widgets: EMPLOYEES_WIDGETS.ROLES_WIDGETS
    },
    ACCESSGROUPS_MODULE: {
      type: 'module',
      id: 'accessgroupOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.ACCESSGROUPS_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.accessgroupOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_rolle.svg'),
      routerLink: '/accessgroups',
      globalSearch: {
        index: 'accessgroups'
      },
      widgets: EMPLOYEES_WIDGETS.ACCESSGROUPS_WIDGETS
    },
    OCCUPATION_GROUPS_MODULE: {
      type: 'module',
      id: 'occupationGroupOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.OCCUPATION_GROUPS_MODULE_WINDOW_ID,
      label: i18n.t(
        'ModuleRegistry.groups.personal.organisation.occupation_group'
      ),
      navigationImg: require('@/assets/navigation/items/icon_beschaeftigungsgruppe.svg'),
      routerLink: '/occupationgroups',
      globalSearch: {
        index: 'occupationgroups'
      },
      widgets: EMPLOYEES_WIDGETS.OCCUPATION_WIDGETS
    },
    GROUPS_MODULE: {
      type: 'module',
      id: 'groupOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.GROUPS_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.organisation.group'),
      navigationImg: require('@/assets/navigation/items/icon_gruppe.svg'),
      routerLink: '/groups',
      globalSearch: {
        index: 'groups'
      },
      widgets: EMPLOYEES_WIDGETS.GROUPS_WIDGETS
    },
    DEPARTMENTS_MODULE: {
      type: 'module',
      id: 'departmentOverview',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.DEPARTMENTS_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.departmentsOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/departments',
      globalSearch: {
        index: 'departments'
      },
      widgets: EMPLOYEES_WIDGETS.DEPARTMENT_WIDGETS
    },
    DEPUTY_TYPE_MODULE: {
      type: 'module',
      id: 'deputytypes',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.DEPUTY_TYPE_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.deputyTypeOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/deputytypes',
      globalSearch: {
        index: 'deputytypes'
      },
    },
    SKILL_MATRIX_MODULE: {
      type: 'module',
      id: 'skillmatrix',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.SKILL_MATRIX_MODULE_WINDOW_ID,
      label: i18n.t('ModuleRegistry.groups.personal.skillMatrixOverview.label'),
      navigationImg: require('@/assets/navigation/items/icon_mitarbeiter.svg'),
      routerLink: '/skillmatrix',
      globalSearch: {
        index: 'skillmatrix',
      },
    },
    CURRICULUM_VITAE_MODULE: {
      type: 'module',
      id: 'curriculumVitae',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.CURRICULUM_VITAE_MODULE_WINDOW_ID,
      label: i18n.t('ConfigFixtures.headers.curriculumVitae'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/curriculumvitae',
      globalSearch: {
        index: 'curriculumvitae'
      },
    },
    SKILL_CATEGORIES_MODULE: {
      type: 'module',
      id: 'skillCategories',
      windowIdentifierType:
        EMPLOYEES_MODULE_WINDOW_IDENTIFIER.SKILL_CATEGORIES_MODULE_WINDOW_ID,
      label: i18n.t('SkillCategories.words.attributes'),
      navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
      routerLink: '/skillcategories',
      globalSearch: {
        index: 'skillcategories'
      },
    }
  }
};
